export const REACT_APP_BACKEND_API = `${process.env.REACT_APP_BACKEND_API}`;

export const PAYMENT_METHOD_STRIPE = "stripe";

export const PAYMENT_METHOD_ETH = "eth";

export const LIMIT_PRODUCT_PER_PAGE = 15;

export const SHIPPING_FEE = 25;

export const CHAIN_ID = +`${process.env.REACT_APP_CHAIN_ID}` as 1 | 4;

export const NODE_URI = `${process.env.REACT_APP_NODE_URI}`;

export const ADDRESS_ZERO = "0x0000000000000000000000000000000000000000";

export const MAX_UINT256 = "115792089237316195423570985008687907853269984665640564039457584007913129639935";

export const PAYMENT_CONTRACT_ADDRESS = `${process.env.REACT_APP_PAYMENT_CONTRACT_ADDRESS}`;

export const TOKENS = {
  ETH: "ETH",
  USDT: "USDT",
};

export const DECIMALS = {
  [TOKENS.ETH]: 18,
  [TOKENS.USDT]: 6,
};

export const TOKEN_PRECISIONS = {
  [TOKENS.ETH]: 5,
  [TOKENS.USDT]: 2,
};

export const TOKEN_ADDRESSES = {
  [TOKENS.ETH]: ADDRESS_ZERO,
  [TOKENS.USDT]: `${process.env.REACT_APP_ETHEREUM_USDT_TOKEN_ADDRESS}`,
};
